<template>
    <v-layout>
        <v-flex xs12>
            <v-card v-if="sideMode&&discDialog">
                <v-card-title class="primary headline white--text">
                    Connectors > {{discItem.name}} > {{'discovered points'|translate}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div style="width: 200px;"><v-switch color="success"
                                                         v-model="discOnlyNew"
                                                         :label="'Unmapped Only'|translate"
                    ></v-switch></div>
                    <v-btn @click="discDialog =false">{{ 'Back to Connectors'|translate }}</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-progress-linear :indeterminate="true" v-if="discLoading"></v-progress-linear>
                    <v-data-table
                        :headers="compactDiscHeaders"
                        disable-initial-sort
                        :items="discPoints"
                        v-if="!discLoading"
                        :expand="expand"
                        item-key="id"
                        :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                        <template v-slot:items="props">
                            <tr @click="props.expanded = !props.expanded">
                                <td class="text-xs-left">{{ props.item.id }}</td>
                                <td class="text-xs-left">{{ props.item.tower }}</td>
                                <td class="text-xs-left">{{ props.item.floor }}</td>
                                <td class="text-xs-left">{{ props.item.equip_type }}</td>
                                <td class="text-xs-left">{{ props.item.equip }}</td>
                                <td class="text-xs-left">{{ props.item.point }}</td>
                                <td class="text-xs-left">{{ props.item.carnot_name }}</td>
                                <td class="text-xs-left">
                                    <v-tooltip top v-if="$can('update', 'Points')">
                                        <template v-slot:activator="{ on }" >
                                            <v-icon
                                                v-on="on"
                                                small
                                                class="mr-2"
                                                @click="addToPoint(props.item)"
                                            >
                                                fa-plus
                                            </v-icon>
                                        </template>
                                        <span>{{'Map'|translate}}</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:expand="props">
                            <v-card flat>
                                <v-card-text class="pa-4">
                                    <v-layout>
                                        <v-flex md6>
                                            <p v-if="props.item.path"><strong>path : </strong>{{props.item.path}}</p>
                                            <p v-if="props.item.sensor_desc"><strong>sensor_desc : </strong>{{props.item.sensor_desc}}</p>
                                            <p v-if="props.item.site"><strong>site : </strong>{{props.item.site}}</p>
                                            <p v-if="props.item.unit"><strong>unit : </strong>{{props.item.unit}}</p>
                                        </v-flex>
                                        <v-flex md6>
                                            <p v-if="props.item.meta"><strong>meta : </strong>{{props.item.meta}}</p>
                                            <p v-if="props.item.equip_meta"><strong>equip_meta : </strong>{{props.item.equip_meta}}</p>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <v-card v-if="!(sideMode&&discDialog)">
                <v-card-title class="headline primary white--text">
                    {{'Connectors'|translate}}
                </v-card-title>
                <v-card-actions v-if="!sideMode">
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Connector')"><v-icon small class="mr-2">fa-plus</v-icon>{{'Add Record'|translate}}</v-btn>
                    <connector-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></connector-dialog>

                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="connectors"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.connector_id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.type }}</td>
        <td>
          <v-icon
            small
            class="mr-2"
            v-if="!sideMode&&$can('update', 'Connector')"
            @click="editItem(props.item)"
          >
            fa-edit
          </v-icon>
            <v-tooltip top v-if="!sideMode&&$can('update', 'Connector')">
                <template v-slot:activator="{ on }" >
                    <v-icon
                        small
                        v-on="on"
                        class="mr-2"
                        @click="runDiscovery(props.item)"
                    >
                        fa-search-plus
                    </v-icon>
                </template>
                <span>{{'Request discovery'|translate}}</span>
            </v-tooltip>

            <v-tooltip top v-if="$can('update', 'Connector')">
                <template v-slot:activator="{ on }" >
                    <v-icon
                        small
                        v-on="on"
                        class="mr-2"
                        @click="liveMode=false; discItem=props.item; showDiscoveryResult(props.item)"
                    >
                        fa-search
                    </v-icon>
                </template>
                <span>{{'View discovered points'|translate}}</span>
            </v-tooltip>
             <v-tooltip top v-if="$can('update', 'Connector')&&allowLive">
                <template v-slot:activator="{ on }" >
                    <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        @click="liveMode=true; discItem=props.item; showDiscoveryResult(props.item)"
                    >
                        fa-search-location
                    </v-icon>
                </template>
                <span>{{'Run live discovery'|translate}}</span>
            </v-tooltip>



          <v-icon
            small
            v-if="!sideMode&&$can('update', 'Connector')"
            @click="deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">{{'Reset'|translate}}</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
                <v-dialog v-if="!sideMode" v-model="discDialog" persistent fullscreen>
                    <v-card v-if="discDialog">
                        <v-card-title class="primary headline white--text">
                            {{discItem.name}} > {{'discovered points'|translate}}
                        </v-card-title>
                        <v-card-text>
                                <v-progress-linear :indeterminate="true" v-if="discLoading"></v-progress-linear>
                                    <v-data-table
                                        :headers="discHeaders"
                                        disable-initial-sort
                                        :items="discPoints"
                                        v-if="!discLoading"
                                        :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                    >
                                        <template v-slot:items="props">
                                            <td class="text-xs-left">{{ props.item.id }}</td>
                                            <td class="text-xs-left">{{ props.item.path }}</td>
                                            <td class="text-xs-left">{{ props.item.tower }}</td>
                                            <td class="text-xs-left">{{ props.item.floor }}</td>
                                            <td class="text-xs-left">{{ props.item.equip_type }}</td>
                                            <td class="text-xs-left">{{ props.item.equip }}</td>
                                            <td class="text-xs-left">{{ props.item.point }}</td>
                                            <td class="text-xs-left">{{ props.item.site }}</td>
                                            <td class="text-xs-left">{{ props.item.carnot_name }}</td>
                                            <td class="text-xs-left">{{ props.item.sensor_desc }}</td>
                                            <td class="text-xs-left">{{ props.item.unit }}</td>
                                            <td class="text-xs-left">{{ props.item.meta }}</td>
                                            <td class="text-xs-left">{{ props.item.equip_meta }}</td>
                                            <td class="text-xs-left">
                                                <v-tooltip top v-if="$can('update', 'Points')">
                                                    <template v-slot:activator="{ on }" >
                                                        <v-icon
                                                            v-on="on"
                                                            small
                                                            class="mr-2"
                                                            @click="addToPoint(props.item)"
                                                        >
                                                            fa-plus
                                                        </v-icon>
                                                    </template>
                                                    <span>{{'Map'|translate}}</span>
                                                </v-tooltip>
                                            </td>
                                        </template>
                                    </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <div style="width: 200px;"><v-switch color="success"
                                                                 v-model="discOnlyNew"
                                                                 :label="'Unmapped Only'|translate"
                            ></v-switch></div>
                            <v-btn @click="exportPoints()" class="mr-2">{{ 'Export'|translate }}</v-btn>
                            <v-btn @click="discDialog =false">{{ 'Close'|translate }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <point-record-dialog v-if="$can('update', 'Points')&&discDialog" v-model="addPointDialog" :item="newPoint" v-on:reloadpoints="refreshPoints"></point-record-dialog>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getConnector, deleteConnector, callAPI, getPoint} from '../helper'
import ConnectorDialog from "../components/ConnectorDialog";
import {exportCSV} from '../tocsv'
import PointRecordDialog from "../components/points/PointRecordDialog";

export default {
    name: 'Connectors',
    props: {
        sideMode: {type: Boolean, default: false},
        equipmentName: {type: String, default: null},
        mappedext: {type: Array, default: null},
    },
  components: { ConnectorDialog,PointRecordDialog },
    computed: {
        discPoints() {
            if (this.discOnlyNew&&this.rawDiscPoints.length>0){
                if (this.sideMode&&this.mappedext){
                    return this.rawDiscPoints.filter(x=>this.mappedext.indexOf(x.id)<0)
                } else {
                    return this.rawDiscPoints.filter(x=>this.mappedIds.indexOf(x.id)<0)
                }
            }
            return this.rawDiscPoints
        },
        allowLive() {
            if (this.$store.state.userStore.user) {
                return this.$store.state.userStore.user.content.user_name==="jecdavid"||this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
            }
            return false;
        },

    },
  data(){
    return{
      dialog: false,
        discDialog:false,
        liveMode:false,
        expand: false,
        addPointDialog:false,
        newPoint:{},
      headers: [
        { text: this.$options.filters.translate('ID'), value: 'conector_id' },
        { text: this.$options.filters.translate('Name'), value: 'name'},
        { text: this.$options.filters.translate('Type'), value: 'type'},
        { text: this.$options.filters.translate('Actions'), sortable: false },
      ],
        rawDiscPoints:[],
        mappedIds:[],
        discOnlyNew:true,
        discHeaders:[
            {
                "text": "id",
                "value": "id"
            },
            {
                "text": "path",
                "value": "path"
            },
            {
                "text": "tower",
                "value": "tower"
            },
            {
                "text": "floor",
                "value": "floor"
            },
            {
                "text": "equip_type",
                "value": "equip_type"
            },
            {
                "text": "equip",
                "value": "equip"
            },
            {
                "text": "point",
                "value": "point"
            },
            {
                "text": "site",
                "value": "site"
            },
            {
                "text": "carnot_name",
                "value": "carnot_name"
            },
            {
                "text": "sensor_desc",
                "value": "sensor_desc"
            },
            {
                "text": "unit",
                "value": "unit"
            },
            {
                "text": "meta",
                "value": "meta"
            },
            {
                "text": "equip_meta",
                "value": "equip_meta"
            },{
                "text": "Actions",
                "sortable": false
            }
        ],
        compactDiscHeaders:[
            {
                "text": "id",
                "value": "id"
            },
            {
                "text": "tower",
                "value": "tower"
            },
            {
                "text": "floor",
                "value": "floor"
            },
            {
                "text": "equip_type",
                "value": "equip_type"
            },
            {
                "text": "equip",
                "value": "equip"
            },
            {
                "text": "point",
                "value": "point"
            },
            {
                "text": "carnot_name",
                "value": "carnot_name"
            },
           {
                "text": "Actions",
                "sortable": false
            }
        ],
      connectors: [],
      editedIndex: -1,
        discLoading:false,
        discItem:{},
      editedItem: {
      },
    }},
    
  mounted() {
    this.initialize()
  },
    methods: {
        addToPoint(item){
            let newPoint=JSON.parse(JSON.stringify({
                facility_name:this.$store.state.pointsListStore.pointsList.facility_name,
                sensor_name:item.carnot_name ? item.carnot_name : item.point,
                sensor_name_abbr:item.carnot_name ? item.point : '',
                unit:item.unit,
                haystack_id:item.id,
                connector_id:this.discItem.connector_id,
                faulty:false,
                weight:1,
            }))
            if (this.sideMode){
                if (this.equipmentName){
                    newPoint.equipment_name=this.equipmentName
                }
                this.$emit('addpoint', newPoint)
            } else {
                this.newPoint=newPoint
                this.addPointDialog=true
            }

        },
      async initialize () {
        await this.refreshPoints()
        await this.refresh()
      },
        async refreshPoints(){
            if (!this.sideMode){
                let df = await getPoint({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                })
                this.mappedIds = df['result'].map(x=>x.haystack_id)
            }
        },
        async runDiscovery(item){
            await callAPI("request-discovery/",{
                connector_id:item.connector_id,
            })
            await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Discovery requested')})
            await this.refresh()
        },
        async showDiscoveryResult(item){
          this.discLoading=true
          this.rawDiscPoints=[]
          this.discDialog=true
            let disc=await callAPI("discovery/",{
                connector_id:item.connector_id,
                live:this.liveMode
            })
            if (disc&&disc.data){
                this.rawDiscPoints=disc.data.result
            }
            this.discLoading=false
        },
        exportPoints() {
            let cleanedItems=JSON.parse(JSON.stringify(this.discPoints))
            exportCSV(cleanedItems)
        },

      editItem (item) {
        this.editedIndex = this.connectors.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.connectors.indexOf(item)
        if (confirm(this.$options.filters.translate('Are you sure you want to delete this connector?')) ){
          this.connectors.splice(index, 1)
          await deleteConnector({
            'connector_id': item.connector_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.connectors[this.editedIndex], this.editedItem)
        } else {
          this.connectors.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getConnector({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.connectors = df['result']
      }
    }
  }
</script>

<style scoped>

</style>
